import { useEmployeeActivationFeature } from '../../features';


export function EmployeeConfirmationPage() {
  return useEmployeeActivationFeature();
}
